import { TranslateService } from '@ngx-translate/core';
import { ChangeDetectorRef, Pipe, PipeTransform } from '@angular/core';

import { OrderType } from '../types';

import { BaseEnumTranslationPipe } from './base-enum-translation.pipe';

@Pipe({ name: 'orderType', pure: false, standalone: true })
export class OrderTypePipe extends BaseEnumTranslationPipe<OrderType> implements PipeTransform {
  protected readonly translationPrefix = 'iss-wo-common.order-type';

  public constructor(translateService: TranslateService, changeDetectorRef: ChangeDetectorRef) {
    super(translateService, changeDetectorRef);
  }
}
